import { type FC, useCallback } from 'react'

import { SwipeAction, TrailingActions } from 'react-swipeable-list'

import { useHasChatUNreadMessages } from '@/models/chattingUI/chats'
import {
  markChatAsReadFx,
  markChatAsUNReadFx,
} from '@/models/chattingUI/chats/chats.ts'

interface Props {
  chatId: number
}

export const Actions: FC<Props> = ({ chatId }) => {
  const hasUnreadMessage = useHasChatUNreadMessages(chatId)

  const handleClickAction = useCallback(() => {
    if (hasUnreadMessage) {
      markChatAsReadFx(chatId)
    } else {
      markChatAsUNReadFx(chatId)
    }
  }, [chatId, hasUnreadMessage])

  return (
    <TrailingActions>
      <SwipeAction
        Tag="div"
        onClick={handleClickAction}
      >
        <div className="flex items-center whitespace-nowrap p-3 text-sm text-secondary-300">
          Mark as {hasUnreadMessage ? 'Read' : 'Unread'}
        </div>
      </SwipeAction>
    </TrailingActions>
  )
}
